<div class="container" style="max-width: 900px; margin: 0 auto; padding: 24px;">
  <h1 style="font-size: 28px; font-weight: 700; color: #1f2937; margin-bottom: 24px;">Impressum</h1>

  <h3 style="font-size: 16px; font-weight: 600; color: #374151; margin-bottom: 12px;">
    Impressum und Offenlegung gem&auml;&szlig; &sect;&sect; 24 und 25 Mediengesetz und Angaben nach &sect; 5 ECG
  </h3>

  <table style="margin-bottom: 24px; font-size: 14px; line-height: 1.8; color: #4b5563;">
    <tr><td style="padding-right: 16px; font-weight: 600; vertical-align: top;">Medieninhaber und Herausgeber:</td><td>Labor C Webengineering GmbH</td></tr>
    <tr><td style="padding-right: 16px; font-weight: 600; vertical-align: top;">Firmensitz:</td><td>Wien</td></tr>
    <tr><td style="padding-right: 16px; font-weight: 600; vertical-align: top;">Rechtsform:</td><td>GmbH</td></tr>
    <tr><td style="padding-right: 16px; font-weight: 600; vertical-align: top;">Firmenbuchnummer:</td><td>FN 210102z</td></tr>
    <tr><td style="padding-right: 16px; font-weight: 600; vertical-align: top;">Firmenbuchgericht:</td><td>Handelsgericht Wien</td></tr>
    <tr><td style="padding-right: 16px; font-weight: 600; vertical-align: top;">Kammerzugeh&ouml;rigkeit:</td><td>Wirtschaftskammer &Ouml;sterreich</td></tr>
    <tr><td style="padding-right: 16px; font-weight: 600; vertical-align: top;">UID-Nr:</td><td>ATU 52032401</td></tr>
    <tr><td style="padding-right: 16px; font-weight: 600; vertical-align: top;">Unternehmensgegenstand:</td><td>Dienstleistung in der automatischen Datenverarbeitung und Informationstechnik; Werbung und Marktkommunikation</td></tr>
    <tr><td style="padding-right: 16px; font-weight: 600; vertical-align: top;">Gesch&auml;ftsf&uuml;hrer:</td><td>Mario Meisenberger, vertritt seit 2001 selbst&auml;ndig</td></tr>
  </table>

  <hr style="margin: 24px 0; border-color: #e5e7eb;" />

  <h3 style="font-size: 16px; font-weight: 600; color: #374151; margin-bottom: 12px;">Copyright</h3>

  <p style="font-size: 14px; line-height: 1.8; color: #4b5563; margin-bottom: 16px;">
    Copyright by Labor C Webengineering GmbH, Pappenheimgasse 33/10, 1200 Wien.
  </p>

  <p style="font-size: 14px; line-height: 1.8; color: #4b5563; margin-bottom: 16px;">
    Inhalt und Struktur dieser Website sind urheberrechtlich gesch&uuml;tzt. Bez&uuml;glich jeglicher geistigen Eigentumsrechte wird keiner Person eine Lizenz oder ein sonstiges Recht einger&auml;umt. Die Vervielf&auml;ltigung von Informationen oder Daten, insbesondere die Verwendung von Texten bzw. Textteilen ist nur f&uuml;r den pers&ouml;nlichen und informativen Gebrauch gestattet. Jede Vervielf&auml;ltigung sowie jeder Gebrauch von Informationen oder Daten ist ausdr&uuml;cklich untersagt und ist nur mit unserer vorherigen Zustimmung zul&auml;ssig.
  </p>

  <hr style="margin: 24px 0; border-color: #e5e7eb;" />

  <h3 style="font-size: 16px; font-weight: 600; color: #374151; margin-bottom: 12px;">Kontakt</h3>

  <p style="font-size: 14px; line-height: 1.8; color: #4b5563; margin-bottom: 16px;">
    Labor C Webengineering GmbH<br />
    Pappenheimgasse 33/10<br />
    1200 Wien<br />
    Tel: 01 / 890 39 54<br />
    E-Mail: <a href="mailto:office@parkraumplus.at" style="color: #4f46e5;">office@parkraumplus.at</a><br />
    Mo&ndash;Do: 09:00 bis 16:00 Uhr
  </p>
</div>
